import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as articuloActions from "../../reducers/articuloReducer/actions";
import * as rubroActions from "../../reducers/rubrosReducer/actions";
import { instalacionSelector } from "../../selectors/sessionSelector";
import { articuloDataSelector } from "../../selectors/articuloSelector";
import { rubrosDataSelector } from "../../selectors/rubrosSelector";
import ArticuloListado from "../../components/Articulo/index";
import * as Notification from "../../components/Common/notification";
import { usuarioSelector, sucursalSelector } from "../../selectors/sessionSelector";
import * as sessionActions from "../../reducers/sessionReducer/actions";
import { sagaGetNiveles } from "../../reducers/nivelesReducer/actions";
import { nivelesDataSelector } from "../../selectors/nivelesSelector";

class ArticulosContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imagenesCargadas: false,
      open: false, //Open modal busqueda avanzada
      openNewModal: false, // Open modal nuevo articulo

      //Estos son para instanciar de antemano los combos. El ultimo si es True, va derecho al componente de articulo nuevo.
      superRubroUnico: false,
      rubroUnico: false,
      ambosUnicos: false,

      //Valores para el manejo de errores en el modal de creacion
      superRubroValidoModal: true,
      rubroValidoModal: true,

      //Filtros
      filtros: {
        idSuperRubro:
          this.props.data &&
          this.props.data.filtrosArticulo &&
          this.props.data.filtrosArticulo.idSuperRubro
            ? this.props.data.filtrosArticulo.idSuperRubro
            : 0,
        idRubro:
          this.props.data &&
          this.props.data.filtrosArticulo &&
          this.props.data.filtrosArticulo.idRubro
            ? this.props.data.filtrosArticulo.idRubro
            : 0,
        idSubRubro:
          this.props.data &&
          this.props.data.filtrosArticulo &&
          this.props.data.filtrosArticulo.idSubRubro
            ? this.props.data.filtrosArticulo.idSubRubro
            : 0,
        Nombre:
          this.props.data &&
          this.props.data.filtrosArticulo &&
          this.props.data.filtrosArticulo.Nombre
            ? this.props.data.filtrosArticulo.Nombre
            : "",
        Codigo:
          this.props.data &&
          this.props.data.filtrosArticulo &&
          this.props.data.filtrosArticulo.Codigo
            ? this.props.data.filtrosArticulo.Codigo
            : "",
      },

      //paginacion
      page: 1,
      pagesize: 40,
      hasmorearticulos: true,
      searchString:
        this.props.data && this.props.data.filtrosArticulo && this.props.data.filtrosArticulo.Nombre
          ? this.props.data.filtrosArticulo.Nombre
          : "", //almacena el valor de busqueda
      searching: false,
      usuarioCargado: false,
      niveles: [],
      allNiveles: [],
      selectedValue: this.props.instalacion?.habilitarNivelListaPrecio === true ? 1 : 0, // valor inicial como entero
      habilitarNivel: false,
    };

    this.props.sagaGetSubRubros(0, null, true);
    this.props.sagaGetRubros(null, true, true);
    this.props.sagaGetSuperRubros();
    this.props.sagaInitialStateArticulo();
    let payload = { ...this.state.filtros };
    payload.page = this.state.page;
    payload.pagesize = this.state.pagesize;

    /*if(this.props.data && this.props.data.filtroArticulo){
            debugger
            payload.Nombre = this.props.data.filtroArticulo
        }*/
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.props.sagaGetNiveles("");
    this.props.sagaGetListadoArticulos(payload);
  }

  handleSelectChange(value) {
    this.setState({ selectedValue: value });
    this.handleOnSearch(this.state.searchString);
  }

  componentDidMount() {
    // carga de datos nivel
    this.setState({
      allNiveles: this.props.niveles.niveles,
      niveles: this.props.niveles.niveles,
      habilitarNivel: this.props.instalacion.habilitarNivelListaPrecio,
    });
  }

  componentDidUpdate = () => {
    if (this.state.usuarioCargado === false && this.props.usuario !== undefined) {
      this.setState({ usuarioCargado: true }, () => {
        if (this.props.usuario.idRol === 4) {
          window.location.hash = "/Pedidos";
        }
      });
    }

    // if (this.state.allNiveles === undefined || this.state.niveles === undefined) {

    // }
    //UPDATE SUCURSAL SELECCIONADA
    const idSucursalLocal = localStorage.getItem("sucursalSeleccionada") || undefined;
    if (
      !this.props.sucursal?.idSucursal &&
      this.props.usuario &&
      this.props.usuario.sucursales?.length !== 0
    ) {
      let sucursalAux = this.props.usuario.sucursales.find(
        (x) => x.idSucursal === parseInt(idSucursalLocal)
      );
      if (sucursalAux) {
        this.props.setSucursal(sucursalAux);
        /*if(usuario && (usuario.idRol === 1 || usuario.idRol === 4)){
                    window.location.hash = '/Pedidos'
                    return
                }
                if(usuario && usuario.idRol === 2){
                    window.location.hash = '/Articulo'
                    return
                }*/
      } else {
        if (this.props.usuario.sucursales.length === 1) {
          localStorage.setItem("sucursalSeleccionada", this.props.usuario.sucursales[0].idSucursal);
          this.props.setSucursal(this.props.usuario.sucursales[0]);
        } else {
          window.location.hash = "/SeleccionSucursal";
        }
      }
    }
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    let filtrosAux = { ...this.state.filtros };
    if (props.dataRubros !== undefined) {
      if (props.dataRubros.superRubros !== undefined && props.dataRubros.rubros !== undefined) {
        if (props.dataRubros.superRubros.length === 1)
          filtrosAux.idSuperRubro = props.dataRubros.superRubros[0].idSuperRubro;

        if (props.dataRubros.rubros.length === 1)
          filtrosAux.idRubro = props.dataRubros.rubros[0].idRubro;

        this.setState({
          imagenesCargadas: true,
          superRubroUnico: props.dataRubros.superRubros.length === 1 ? true : false,
          rubroUnico: props.dataRubros.rubros.length === 1 ? true : false,
          ambosUnicos:
            props.dataRubros.rubros.length === 1 && props.dataRubros.superRubros.length === 1
              ? true
              : false,
          filtros: filtrosAux,
        });
      }
    }
  };

  handleOnSearchAdvanced = () => {
    this.setState({
      open: true,
    });
  };

  handleOnSearch = (searchString) => {
    let payload = {};
    if (searchString.length < 255) {
      payload.page = 1;
      payload.pagesize = this.state.pagesize;

      let filtros = {
        idSuperRubro: 0,
        idRubro: 0,
        idSubRubro: 0,
        Nombre: searchString,
        Codigo: "",
        idNivel: this.state.selectedValue,
      };
      this.setState(
        {
          page: 1,
          searchString: searchString,
          filtros: filtros,
        },
        () => {
          payload.Nombre = searchString;
          payload.idNivel = this.state.selectedValue;
          this.props.sagaInitialStateArticulo();
          this.props.setFilterBusquedaArticulo(filtros);
          this.props.sagaGetListadoArticulos(payload);
        }
      );
    } else {
      Notification.showError("Exceso de caracteres. Revise la búsqueda.");
    }
  };

  fetchMoreArticulos = () => {
    if (this.props.data.listadoArticulo !== undefined) {
      if (this.state.searching === false) {
        let payload = this.state.filtros;
        let nextpage = this.state.page + 1;
        if (nextpage <= this.props.data.listadoArticulo.totalPaginas) {
          payload.Callback = () => {
            let filtroAux = { ...this.state.filtros };
            filtroAux.idSuperRubro = this.state.superRubroUnico ? 1 : 0;
            this.setState({
              open: false,
              filtros: filtroAux,
              searching: false,
            });
          };
          payload.page = nextpage;
          payload.pagesize = this.state.pagesize;
          if (this.state.searchString !== "") {
            payload.Nombre = this.state.searchString;
          }

          this.setState({
            searching: true,
          });

          this.props.sagaGetListadoArticulos(payload);

          this.setState(() => ({
            page: nextpage,
            hasmorearticulos: nextpage + 1 < this.props.data.listadoArticulo.totalPaginas,
          }));
        } else {
          this.setState({
            hasmorearticulos: false,
          });
        }
      }
    }
  };

  getImgArticulo = (idArticulo) => {
    let flag = true;

    if (
      this.props.match.params.getCatalogo !== "true" &&
      this.props.imagenesArticulos !== undefined
    ) {
      this.props.imagenesArticulos.forEach((img) => {
        if (img.idArticulo === idArticulo) {
          flag = false;
        }
      });
    }
    if (flag) {
      let payload = {};
      payload.idArticulo = idArticulo;
      payload.listaCompleta = false;
      this.props.sagaGetImagenesListadoArticulos(payload);
    }
  };

  handleIdSuperRubro = (e) => {
    let filtroAux = { ...this.state.filtros };
    filtroAux.idSuperRubro = e.target.value;
    this.setState({
      filtros: filtroAux,
    });
  };

  handleIdRubro = (e) => {
    let filtroAux = { ...this.state.filtros };
    filtroAux.idRubro = e.target.value;

    this.setState({
      filtros: filtroAux,
    });
  };

  handleIdSubRubro = (e) => {
    let filtroAux = { ...this.state.filtros };
    filtroAux.idSubRubro = e.target.value;

    this.setState({
      filtros: filtroAux,
    });
  };

  handleNombreArticulo = (e) => {
    let filtroAux = { ...this.state.filtros };

    filtroAux.Nombre = e.target.value;

    this.setState({
      filtros: filtroAux,
    });
  };

  handleCodigoArticulo = (e) => {
    let filtroAux = { ...this.state.filtros };

    filtroAux.Codigo = e.target.value;

    this.setState({
      filtros: filtroAux,
    });
  };

  handleCloseModal = () => {
    let filtroAux = { ...this.state.filtros };
    filtroAux.idSuperRubro = this.state.superRubroUnico
      ? this.props.dataRubros.superRubros[0].idSuperRubro
      : 0;
    //filtroAux.idRubro = 0
    //filtroAux.idSubRubro = 0
    //filtroAux.Nombre = ''
    //filtroAux.Codigo = ''
    this.setState({
      open: false,
      //filtros : filtroAux,
      superRubroValidoModal: true,
      rubroValidoModal: true,
    });
  };

  handleOnAdvanceSearch = () => {
    if (this.validar()) {
      let payload = { ...this.state.filtros };
      payload.page = 1;
      payload.pagesize = this.state.pagesize;
      payload.Callback = () => {
        //let filtroAux = {...this.state.filtros}
        //filtroAux.idSuperRubro = this.state.superRubroUnico ? 1: 0
        //filtroAux.idRubro = 0
        //filtroAux.idSubRubro = 0
        //filtroAux.Nombre = ''
        //filtroAux.Codigo = ''
        this.setState({
          page: 1,
          open: false,
          searchString: "",
          //filtros : filtroAux
        });
      };

      this.props.sagaInitialStateArticulo();
      let filters = { ...this.state.filtros };
      this.props.setFilterBusquedaArticulo(filters);
      this.props.sagaGetListadoArticulos(payload);
    }
  };

  validarNombre = () => {
    if (this.state.filtros.Nombre.length > 255) {
      return false;
    }
    return true;
  };

  validarCodigo = () => {
    if (this.state.filtros.Codigo.length > 255) {
      return false;
    }
    return true;
  };

  validar = () => {
    if (this.state.filtros.Nombre.length > 255) {
      return false;
    }
    if (this.state.filtros.Codigo.length > 255) {
      return false;
    }

    return true;
  };

  handleOnNewButton = () => {
    if (this.state.ambosUnicos === false) {
      //si hay mas de un rubro o mas de un superrubro
      this.setState({
        openNewModal: true,
      });
    } else {
      // si es true, significa que ambos son unicos, asi que vamos a ir por ahi.
      if (this.props.dataRubros.superRubros[0].nombre === "Textil") {
        //PUSH A ARTICULOTEXTILNUEVO
        this.props.history.push({
          pathname: "/Articulo/articuloNuevo",
          payloadRubro: this.props.dataRubros.rubros[0].idRubro,
          idCatalogo: -1, // Colocaremos -1 como convención para simular un articulo sin catalogo definido
        });
      }

      if (this.props.dataRubros.superRubros[0].nombre === "Generico") {
        this.props.history.push(
          "/Articulo/articuloGenericoNuevo/" +
            this.props.dataRubros.superRubros[0].idSuperRubro +
            "/" +
            this.props.dataRubros.rubros[0].idRubro
        );
        //PUSH A ARTICULOGENERICONUEVO.
      }
    }
  };

  handleCloseModalNuevo = () => {
    let filtroAux = { ...this.state.filtros };
    filtroAux.idSuperRubro = this.state.superRubroUnico
      ? this.props.dataRubros.superRubros[0].idSuperRubro
      : 0;
    filtroAux.idRubro = this.state.rubroUnico ? this.props.dataRubros.rubros[0].idRubro : 0;
    filtroAux.idSubRubro = 0;
    filtroAux.Nombre = "";
    filtroAux.Codigo = "";
    this.setState({
      openNewModal: false,
      filtros: filtroAux,
      superRubroValidoModal: true,
      rubroValidoModal: true,
    });
  };

  handleCreateArticuloFromModal = (idRubro, idSuperRubro) => {
    if (idRubro !== 0 && idSuperRubro !== 0) {
      let superRubro = this.props.dataRubros.superRubros.find((superRubro) => {
        return superRubro.idSuperRubro === idSuperRubro;
      });

      if (superRubro.nombre == "Generico" || superRubro.nombre == "Genérico") {
        //PUSH A ARTICULOGENERICONUEVO.
        this.props.history.push("/Articulo/articuloGenericoNuevo/" + idSuperRubro + "/" + idRubro);
      }

      if (superRubro.nombre == "Textil") {
        //PUSH A ARTICULOTEXTILNUEVO
        this.props.history.push({
          pathname: "/Articulo/articuloNuevo",
          payloadRubro: idRubro,
          idCatalogo: -1, // Colocaremos -1 como convención para simular un articulo sin catalogo definido
        });
      }
    } else {
      this.setState({
        rubroValidoModal: idRubro === 0 ? false : true,
        superRubroValidoModal: idSuperRubro === 0 ? false : true,
      });
    }
  };

  handleClickEditarArticulo = (isGenerico, idSuperRubro, idRubro, idArticulo) => {
    if (isGenerico == false) {
      this.props.history.push({
        pathname: "/Articulo/articuloNuevo/0/" + idArticulo,
        payloadRubro: idRubro,
        //idCatalogo: -1,  // Colocaremos -1 como convención para simular un articulo sin catalogo definido
        idArticulo: idArticulo,
      });
    } else {
      this.props.history.push(
        "/Articulo/articuloGenericoNuevo/" + idSuperRubro + "/" + idRubro + "/" + idArticulo
      );
    }
  };

  render() {
    return (
      <ArticuloListado
        handleOnSearchAdvanced={this.handleOnSearchAdvanced}
        handleOnSearch={this.handleOnSearch}
        listadoArticulo={
          this.props.data.listadoArticulo !== undefined
            ? this.props.data.listadoArticulo
            : undefined
        }
        fetchMoreArticulos={this.fetchMoreArticulos}
        hasMoreArticulos={this.state.hasmorearticulos}
        getImgArticulo={this.getImgArticulo}
        handleClickEditarArticulo={this.handleClickEditarArticulo}
        open={this.state.open}
        superRubros={this.props.dataRubros.superRubros}
        rubros={this.props.dataRubros.rubros}
        subrubros={this.props.dataRubros.subrubros}
        filtros={this.state.filtros}
        handleIdSuperRubro={this.handleIdSuperRubro}
        handleIdRubro={this.handleIdRubro}
        handleIdSubRubro={this.handleIdSubRubro}
        handleCloseModal={this.handleCloseModal}
        handleNombreArticulo={this.handleNombreArticulo}
        handleCodigoArticulo={this.handleCodigoArticulo}
        handleOnAdvanceSearch={this.handleOnAdvanceSearch}
        superRubroUnico={this.state.superRubroUnico}
        rubroUnico={this.state.rubroUnico}
        validar={this.validar}
        validarNombre={this.validarNombre}
        validarCodigo={this.validarCodigo}
        openNewModal={this.state.openNewModal}
        handleOnNewButton={this.handleOnNewButton}
        handleCloseModalNuevo={this.handleCloseModalNuevo}
        handleCreateArticuloFromModal={this.handleCreateArticuloFromModal}
        superRubroValidoModal={this.state.superRubroValidoModal}
        rubroValidoModal={this.state.rubroValidoModal}
        currentPage={this.state.page}
        pageSize={this.state.pageSize}
        filtroArticulo={this.state.searchString}
        instalacion={this.props.instalacion}
        niveles={this.state.allNiveles}
        selectedValue={this.state.selectedValue}
        onSelectChange={this.handleSelectChange}
        habilitarNivel={this.state.habilitarNivel}
      />
    );
  }
}

ArticulosContainer.propTypes = {};

ArticulosContainer.defaultProps = {};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...articuloActions,
      ...rubroActions,
      ...sessionActions,
      sagaGetNiveles,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    data: articuloDataSelector(state),
    dataRubros: rubrosDataSelector(state),
    usuario: usuarioSelector(state),
    sucursal: sucursalSelector(state),
    instalacion: instalacionSelector(state),
    niveles: nivelesDataSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticulosContainer);
